<template>
  <div class="contenedor">
    <div class="row">
      <div class="col-sm-12">
        <div class="col-md-2" v-if="!loadingOwarmList">
          <select
            v-model="client_id"
            class="form-control"
            @change="changeClientId(client_id)"
          >
            <option value="0">{{ $t("lang.button.all") }}</option>
            <option v-for="team in groups" :value="team.id">
              {{ team.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-12 col-xl-5 order-1 order-xl-2">
        <div class="mt-3">
          <LoadingSpinner v-if="loadOwarmStats" />
          <div v-else>
            <div class="row">
              <div class="col-12">
                <h3 v-if="accountSelected">{{ accountSelected }}</h3>
                <line-chart
                  class="d-block"
                  :width="300"
                  :height="100"
                  :chart-data="multiaxisOwarm"
                  :options="multiaxisOwarm.options"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-xl-7 order-2 order-xl-1">
        <LoadingSpinner v-if="loadingOwarmList" />
        <div
          class="pt-2 pl-4 d-flex justify-content-between bd-highlight mb-3"
          v-if="!loadingOwarmList && owarmList.list.length > 0"
        >
          <div class="bd-highlight">
            {{ $t("lang.label.results") }}:
            <small v-if="!total" class="ml-1 text-primary"
              >{{ $t("lang.search.calculating") }}...</small
            >
            <strong v-else>{{ total }}</strong>
          </div>
          <div>
            <Pagination
              v-if="!loadingOwarmList"
              :total="total"
              :totalpage="owarmList.list.length"
              :model="model"
              color="primary"
              :limit="false"
              @changePage="changePage"
              :key="paginationkey"
            ></Pagination>
          </div>
          <div>.</div>
        </div>

        <div
          class="px-4"
          style="overflow-x: scroll"
          v-if="!loadingOwarmList && owarmList.list.length > 0"
        >
          <Table
            v-if="!loadingOwarmList && owarmList.list.length > 0"
            :headers="headers4"
            :cols="cols4"
            :data="owarmList.list"
            :checkbox="false"
            :notselect="true"
            :model="model"
            @getOwarmStats="getOwarmStats"
          >
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  statusBadgeMixin,
  statusPointMixin,
  statusFeedNotificationsMixin,
  formattersMixin,
} from "@/_mixins/";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";
import LineChart from "@/components/Chart.vue";
import { adminService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  props: {
    groups: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      model: {},
      client_id: 0,
      paginationkey: 0,
      total: 0,
      loadingOwarmList: true,
      cantPerPage: 25,
      accountSelected: false,
      headers4: [
        {
          label: this.$t("lang.label.email"),
          size: "200px",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.client"),
          size: "100px",
          class: "overflowhide",
        },
        {
          label: "User Linked",
          size: "130px",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.firstname"),
          size: "130px",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.lastname"),
          size: "100px",
          class: "overflowhide",
        },
        {
          label: "Start",
          size: "140px",
          class: "overflowhide",
        },
        {
          label: "Status",
          size: "100px",
          class: "overflowhide",
        },
        {
          label: "Spam",
          size: "70px",
          class: "overflowhide",
        },
      ],
      cols4: [
        [
          {
            value_label: "email",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "getOwarmStats",
            icon: "icon-bar-chart text-primary pr-2",
          },
        ],
        [
          {
            value: "client_name",
          },
        ],
        [
          {
            value: "user_email",
          },
        ],
        [
          {
            value: "name",
          },
        ],
        [
          {
            value: "lastname",
          },
        ],
        [
          {
            value: "start_on",
          },
        ],
        [
          {
            value: "owarm_status",
          },
        ],
        [
          {
            value: "spam_rate",
          },
        ],
      ],
      openchart: false,
      owarmStats: [],
      owarmList: [],
      loadingOwarmList: true,
      loadOwarmStats: true,
      owarmOptions: [
        {
          // [0]
          id: "inbox",
          label: "inbox",
          role: ["1"],
          isDisabled: false,
          color: "51, 204, 204",
          yAxisID: "y1",
          type: "bar",
        },
        {
          // [1]
          id: "spam",
          label: "spam",
          role: ["1"],
          isDisabled: false,
          color: "255,0,0",
          yAxisID: "y1",
          type: "bar",
        },
        {
          // [2]
          id: "missing",
          label: "missing",
          role: ["1"],
          isDisabled: false,
          color: "155, 155, 155",
          yAxisID: "y1",
          type: "bar",
        },
        {
          // [3]
          id: "replies",
          label: "replies",
          role: ["1"],
          isDisabled: false,
          color: "0, 128, 0",
          yAxisID: "y1",
          type: "line",
        },
        {
          id: "accounts",
          label: "accounts",
          role: ["1"],
          isDisabled: false,
          color: "0, 32, 255",
          yAxisID: "y2",
          type: "line",
        },
      ],

      multiaxisOwarm: {
        labels: [],
        datasets: [],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.$t("lang.label.activity"),
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                id: "y1",
                stacked: true,
                position: "right",
                display: true,
                gridLines: {
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
              {
                type: "linear",
                id: "y2",
                position: "left",
                display: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "day",
                },
                stacked: true,
                offset: true,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || "";

                if (label) {
                  label += ": ";
                }

                var currentQty = tooltipItem.yLabel; // data.datasets[tooltipItem.datasetIndex].data;
                console.log(data.datasets);
                label += currentQty;
                 console.log(tooltipItem )
                // [0] inbox, [1] spam, [2] missing, [3] replies
                if ([0, 1, 3].includes(tooltipItem.datasetIndex)) {
                  let total =
                    parseInt(data.datasets[0].data[tooltipItem.index]) +
                    parseInt(data.datasets[1].data[tooltipItem.index]);
                  label += " ("
                  label +=
                    parseFloat(
                      (currentQty * 100) /
                        total
                    ).toFixed(2) + "%)";
                } else if( tooltipItem.datasetIndex == 2){
                  let total =
                    parseInt(data.datasets[0].data[tooltipItem.index]) +
                    parseInt(data.datasets[1].data[tooltipItem.index]) +
                    parseInt(data.datasets[2].data[tooltipItem.index]);
                  label += " ("
                  label +=
                    parseFloat(
                      (currentQty * 100) /
                        total
                    ).toFixed(2) + "%)";
                }

                // if(tooltipItem.datasetIndex == 0){

                // }else if(tooltipItem.datasetIndex == 1){

                // }else if(tooltipItem.datasetIndex == 2){

                // }

                return label;
              },
            },
          },
        },
      },
    };
  },
  components: {
    LineChart,
    LoadingSpinner,
    Table,
    Pagination,
  },

  mixins: [
    statusBadgeMixin,
    statusPointMixin,
    statusFeedNotificationsMixin,
    formattersMixin,
  ],

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
  },

  created() {
    if (this.model.cantPerPage == undefined) {
      this.model.currentPage = 1;
      this.model.cantPerPage = this.cantPerPage;
    }

    this.search();
    this.getOwarmStats();
  },

  methods: {
    getOwarmStats(id) {
      this.accountSelected = false;
      this.model.from_owarm_id = undefined;
      if (id !== undefined) {
        let account = this.owarmList.list.filter((item) => item.id == id);
        this.accountSelected = account[0].email;
        this.model.from_owarm_id = parseInt(id);
      }
      this.loadOwarmStats = true;
      this.multiaxisOwarm.datasets = [];
      adminService.getOwarmStats(this.model).then((result) => {
        this.owarmStats = result;
        this.multiaxisOwarm.labels = this.owarmStats.labels;
        this.owarmOptions.forEach((value, index) => {
          this.multiaxisOwarm.datasets.push({
            type: value.type,
            label: value.label,
            hidden: false,
            borderColor: "RGBA(" + value.color + ",1)",
            backgroundColor: "RGBA(" + value.color + ",0.5)",
            pointBackgroundColor: "RGBA(" + value.color + ",1)",
            yAxisID: value.yAxisID,
            data: this.owarmStats[value.id],
          });
        });

        this.loadOwarmStats = false;
      });
    },
    search() {
      this.changePage();
      adminService.getOwarmListTotal(this.model).then((response) => {
        if (response !== undefined) {
          this.total = parseInt(response.total);
        }
      });
    },
    changePage() {
      this.loadingOwarmList = true;
      adminService.getOwarmList(this.model).then((result) => {
        this.owarmList = result;
        this.loadingOwarmList = false;
        this.keyresult++;
      });
    },
    changeClientId(client_id) {
      this.model.client_id = parseInt(client_id);
      this.search();
      this.getOwarmStats();
    },
  },
};
</script>

<style scoped>
</style>